import React, { useState, useRef, useEffect } from "react";
import style from "./styles.module.scss";
import AppStatusDot from "../../pages/application/components/AppStatusDot/AppStatusDot";
import CaretDown from "../../assets/svg/icons/common/CaretDown";

function AppStatusDropDown({ options, progression_id, onChange, disabled }) {
  const [isOpen, setIsOpen] = useState(false);

  const dropDownRef = useRef(null);

  useEffect(() => {
    // Close drop-down when clicking outside
    function handleClickOutside(event) {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const progression_statuses = [
    {
      progression_id: 0,
      color: "orange",
      name: "Awaiting Preapp",
    },
    {
      progression_id: 1,
      color: "orange",
      name: "Awaiting Preapp",
    },
    {
      progression_id: 2,
      color: "orange",
      name: "Awaiting Business Profile",
    },
    {
      progression_id: 3,
      color: "orange",
      name: "Awaiting Pricing",
    },
    {
      progression_id: 4,
      color: "orange",
      name: "Awaiting Pricing Confirmation",
    },
    {
      progression_id: 5,
      color: "orange",
      name: "Awaiting For Equipments",
    },
    {
      progression_id: 6,
      color: "orange",
      name: "Awaiting Signature Request",
    },
    {
      progression_id: 7,
      color: "#F0BE74",
      name: "Sent for Signature / Awaiting Signature",
    },
    {
      progression_id: 8,
      color: "#819FEC",
      name: "Signed-PC Review",
    },
    {
      progression_id: 9,
      color: "#7FCECE",
      name: "UW Review",
    },
    {
      progression_id: 10,
      color: "#E7B8DF",
      name: "Pended",
    },
    {
      progression_id: 11,
      color: "#44AE42",
      name: "Reserve Req",
    },
    {
      progression_id: 12,
      color: "#44AE42",
      name: "Approved",
    },
    {
      progression_id: 13,
      color: "#FFA500",
      name: "Declined",
    },
    {
      progression_id: 14,
      color: "#660000",
      name: "Cancelled",
    },
    {
      progression_id: 15,
      color: "#44AE42",
      name: "App pending PC approval",
    },
    {
      progression_id: 16,
      color: "#F0BE74",
      name: "Sent for Signature",
    },
    {
      progression_id: 17,
      color: "#F0BE74",
      name: "PDF requested",
    },
    {
      progression_id: 18,
      color: "#F0BE74",
      name: "Awaiting wet signature",
    },
    {
      progression_id: 19,
      color: "#7f7f7f",
      name: "Pending Prevet",
    },
    {
      progression_id: 20,
      color: "#e6e612",
      name: "Approved Prevet",
    },
    {
      progression_id: 21,
      color: "#FF0000",
      name: "Terminated",
    },
    {
      progression_id: 22,
      color: "#0000FF",
      name: "Support",
    },
  ];

  return (
    <div className={style.container} ref={dropDownRef}>
      <button
        className={`${style.status_button} ${disabled ? style.disabled : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <AppStatusDot progression_id={progression_id} />
        <CaretDown />
      </button>

      {isOpen && (
        <div className={`${style.drop_down_content}`}>
          {options.map((item) => {
            return (
              <div
                key={item.value}
                className={`${style.drop_down_items} ${item.value === progression_id ? style.active : ""}`}
                onClick={() => onChange({ progression_id: item.value })}
              >
                <div
                  className={style.dot}
                  style={{ backgroundColor: item.color }}
                ></div>
                <p>{item.label}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default AppStatusDropDown;
